// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__Hpfus","label":"Completed_label__JG-2H"};